import type { FailureScope, SourceStatement, SourceRetryWarning } from '@unni-craftsman/turso-fts-common'
import type { SourceTransactionContext } from '../source-transaction'

/** Own the immutable native replay input before it waits behind another transaction. */
export function copySourceBatch(scope: FailureScope, statements: readonly SourceStatement[]) {
  return {
    scope: { ...scope, replica: new Uint8Array(scope.replica) },
    statements: statements.map(statement => ({
      sql: statement.sql,
      params: statement.params?.map(value => value instanceof Uint8Array ? new Uint8Array(value) : value),
    })),
  }
}

/** Native warning data crosses RPC; callbacks and native handles stay with their owner. */
export type SourceCallCompletion = { warnings: SourceRetryWarning[] }
export function validateSourceCallContext(context: SourceTransactionContext): void {
  if (context.operation || context.capture) throw new Error('Native source capture handles cannot cross a worker boundary')
}
export function deliverSourceCompletion(completion: SourceCallCompletion | undefined, context: SourceTransactionContext): void {
  if (!completion) return
  for (const warning of completion.warnings) {
    try { context.onRetryWarning?.(warning) } catch { /* Optional native warning cannot replace the decided database outcome. */ }
  }
}
